import { FormRow } from "./FormRow";
import { FC } from "react";

export const InfoRow: FC<{ infoText: string }> = ({ infoText }) => {
  return (
    <FormRow
      labelHtmlFor="No controls"
      labelText={infoText}
      className="hidden"
    />
  );
};
